import PartnerModuleSlice from "../slices/partnermodule.slice";
import InsurancetypeSlice from "../slices/Insurancetype.slice";
import insuranceFormSlice from "../slices/insuraneform.slice";
import DashboardSlice from "../slices/dashboard.slice";
import InsuranceSlice from "../slices/insurance.slice";
import DeliverySlice from "../slices/delivery.slice";
import { combineReducers } from "@reduxjs/toolkit";
import PartnerSlice from "../slices/partner.slice";
import MessageSlice from "../slices/message.slice";
import SidebarSlice from "../slices/sidebarslice";
import FilterSlice from "../slices/filter.slice";
import CouponSlice from "../slices/coupon.slice";
import AdminSlice from "../slices/admin.slice";
import UsersSlice from "../slices/users.slice";
import otherSlice from "../slices/other.slice";
import EmailSlice from "../slices/email.slice";
import RideSlice from "../slices/rides.slice";
import AuthSlice from "../slices/auth.slice";
import PlanSlice from "../slices/plan.slice";
import RoleSlice from "../slices/role.slice";

const rootReducer = combineReducers({
  PlanSlice,
  RideSlice,
  AuthSlice,
  RoleSlice,
  EmailSlice,
  otherSlice,
  UsersSlice,
  AdminSlice,
  FilterSlice,
  CouponSlice,
  PartnerSlice,
  MessageSlice,
  SidebarSlice,
  DeliverySlice,
  InsuranceSlice,
  DashboardSlice,
  insuranceFormSlice,
  PartnerModuleSlice,
  InsurancetypeSlice,
})

export default rootReducer